import {StepsQuestionsView} from '../models/client-questions';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';

@Injectable()
export class ClientQuestionsService {
  constructor(private http: HttpClient) {
  }

  public getClientQuestion(typeId: number): Observable<StepsQuestionsView> {
    return this.http.get<StepsQuestionsView>(`${environment.apiUrl}/api/comparison/${typeId}/questions`).pipe(
      map((response: StepsQuestionsView) => new StepsQuestionsView(response))
    );
  }

}

